import { createAsyncThunk } from "@reduxjs/toolkit";
import { myExpariencesService } from "../../services";

export const fetchMyExpariences = createAsyncThunk(
  'expariences/fetchMyExpariences',
  async (infos, { rejectWithValue }) => {
    let response;
    if (infos?.isUserApi)
    response = await myExpariencesService.fetchUserExpariences(
      infos?.hasOwnProperty('offset') ? infos.offset : 'default',
      infos?.hasOwnProperty('limit') ? infos.limit : 'default',
      )
    else
      response = await myExpariencesService.fetchMyExpariences(
        infos?.hasOwnProperty('offset') ? infos.offset : 'default',
        infos?.hasOwnProperty('limit') ? infos.limit : 'default',
        )
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return {
      response,
      concat: !(infos?.offset === 'default' && infos?.limit === 'default') || false,
      reset: infos?.hasOwnProperty('reset') ? infos.reset : false,
      dma: infos?.hasOwnProperty('dma') ? infos.dma : false,
    };
  }
)

export const fetchSingleExparience = createAsyncThunk(
  'expariences/fetchSingleExparience',
  async (infos, { rejectWithValue }) => {
    const response = await myExpariencesService.fetchSingleExparience(infos.id, infos.isAdmin)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const deleteExparience = createAsyncThunk(
  'expariences/deleteExparience',
  async (id, { rejectWithValue }) => {
    const response = await myExpariencesService.deleteExparience(id)
    if (!response)
      return rejectWithValue('offline')
    if (response.status > 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const updatePublication = createAsyncThunk(
  'expariences/updatePublication',
  async (infos, { rejectWithValue }) => {
    const response = await myExpariencesService.updatePublication(infos.id, infos.value, infos.isAdmin)
    if (!response)
      return rejectWithValue('offline')
    if (response.status > 300)
      return rejectWithValue('An error has occured, try again later')
    return infos;
  }
)

export const updateVisible = createAsyncThunk(
  'expariences/updateVisible',
  async (infos, { rejectWithValue }) => {
    const response = await myExpariencesService.updateVisible(infos.id, infos.isAdmin, infos.visible)
    if (!response)
      return rejectWithValue('offline')
    if (response.status > 300)
      return rejectWithValue('An error has occured, try again later')
    return infos;
  }
)